import React from 'react';
import { withRouter } from 'react-router-dom';
import withStyles from 'react-jss';
import i18n from 'i18next';
import { Translation } from 'react-i18next';
import Chevron from './utility/Chevron';
import DashboardButton from './utility/DashboardButton';
import ToolTipIcon from '../utility/ToolTipIcon';

const styles = {
  color: (props) => ({
    backgroundColor: props.tenant.primary,
    border: `2px solid ${props.tenant.primary} !important`,
    color: 'white !important',

    '&:hover': {
      backgroundColor: 'white',
      border: `2px solid ${props.tenant.primary} !important`,
      color: `${props.tenant.primary} !important`,
      borderStyle: 'solid',
    },
  }),
};

class SMCDashTakeAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chevronColor1: 'white',
      chevronColor2: 'white',
      showToolTip: false,
    };
    this.toolTipClickContainer = React.createRef();
  }

  componentDidMount = () => {
    window.addEventListener('click', (e) => this.closeToolTip(e));
  };

  componentWillUnmount = () => {
    window.removeEventListener('click', (e) => this.closeToolTip(e));
  };

  closeToolTip = (e) => {
    if (!this.toolTipClickContainer?.current?.contains(e.target)) {
      this.setState({ showToolTip: false });
    }
  };

  displayDashboardButtons = (dashButtons, button) => {
    const buttonDetails = dashButtons[button];
    return (
      <DashboardButton
        button={button}
        buttonDetails={buttonDetails}
        key={button}
      />
    );
  };

  changeChevronColor = (color, index) => {
    this.setState({
      [`chevronColor${index}`]: color,
    });
  };

  displayCurrentlyEnrolledButtons = (button, index) => {
    const color = this.state[`chevronColor${index + 1}`];
    return (
      <a
        key={`${button.label}${index}`}
        href={button.value}
        rel="noreferrer noopener"
        target="_blank"
        tabIndex={0}
        className={`button--primary take-action-learn-more-button ${this.props.classes.color}`}
        onMouseEnter={() =>
          this.changeChevronColor(this.props.tenant.primary, index + 1)
        }
        onMouseLeave={() => this.changeChevronColor('white', index + 1)}
      >
        {button.label}
        <Chevron color={color} hide />
      </a>
    );
  };

  toggleToolTip = (bool) => {
    this.setState({
      showToolTip: bool,
    });
  };

  get smcInfoIconTooltip() {
    return i18n.t(
      'For new students, incoming transfer students, or students who have been away from {{university}} for more than one year.',
      { university: 'SMC' }
    );
  }

  render() {
    const dashButtons = {};
    Object.keys(this.props.tenant.buttonInfo).forEach((key) => {
      if (
        this.props.tenant.buttonInfo[key] &&
        (key === 'button3' || key === 'button4')
      ) {
        dashButtons[key] = this.props.tenant.buttonInfo[key];
      }
    });
    const { buttonInfo } = this.props.tenant;
    return (
      <Translation>
        {(t) => (
          <div id="take-action-learn-more">
            <div className="take-action">
              <div className="section-heading">
                {t('Currently enrolled students:')}
              </div>
              <div className="section-buttons border-right">
                {[buttonInfo.button1, buttonInfo.button2].map((x, index) =>
                  this.displayCurrentlyEnrolledButtons(x, index)
                )}
              </div>
            </div>
            <div className="learn-more">
              <div className="section-heading">
                {t('New, transfer, and returning students: ')}
                <div
                  tabIndex={0}
                  role="button"
                  ref={this.toolTipClickContainer}
                  onClick={() => this.toggleToolTip(true)}
                  onKeyDown={(e) => {
                    if (['Enter'].includes(e.target)) this.toggleToolTip(true);
                  }}
                  onFocus={() => this.toggleToolTip(true)}
                  onBlur={() => this.toggleToolTip(false)}
                  className="contain-tooltipicon-component"
                >
                  <ToolTipIcon
                    color={this.props.tenant.primary}
                    tooltip={this.smcInfoIconTooltip}
                    showToolTip={this.state.showToolTip}
                    ariaLabel={this.smcInfoIconTooltip}
                  />
                </div>
              </div>
              <div className="section-buttons">
                {Object.keys(dashButtons).map((button) => {
                  return (
                    <span key={button}>
                      {this.displayDashboardButtons(dashButtons, button)}
                    </span>
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

const SMCDashTakeActionWithRouter = withRouter(SMCDashTakeAction);
export default withStyles(styles)(SMCDashTakeActionWithRouter);
